import { useState, useCallback } from "react";
const DefaultAnimationDuration = 8e3;
const DefaultStaticTitle = "Analyse your fit";
const Titles = [
  "Analysing your fit",
  "Summarising",
  "Defining next steps",
  "Aligning your skills"
];
const DefaultDotDuration = DefaultAnimationDuration / 1e3 / Titles.length;
const useAnimatedTitles = (targetAnimatedTime = DefaultAnimationDuration) => {
  const [title, setTitle] = useState(DefaultStaticTitle);
  const [timeoutIds, setTimeoutIds] = useState([]);
  const [isLoadingAnimation, setIsLoadingAnimation] = useState(false);
  const clearAllTimeouts = useCallback(() => {
    timeoutIds.forEach((id) => clearTimeout(id));
    setTimeoutIds([]);
  }, [timeoutIds]);
  const loadAnimatedTitles = useCallback(() => {
    const interval = targetAnimatedTime / Titles.length;
    setIsLoadingAnimation(true);
    Titles.forEach((titleLabel, index) => {
      const tempId = setTimeout(() => {
        setTitle(titleLabel);
      }, interval * index);
      setTimeoutIds((prev) => [...prev, tempId]);
    });
    setTimeout(() => {
      setIsLoadingAnimation(false);
    }, targetAnimatedTime);
  }, [targetAnimatedTime]);
  const clearAnimation = useCallback(() => {
    setIsLoadingAnimation(false);
    clearAllTimeouts();
    setTitle(DefaultStaticTitle);
  }, [clearAllTimeouts]);
  return { title, loadAnimatedTitles, isLoadingAnimation, clearAnimation };
};
export {
  DefaultAnimationDuration,
  DefaultDotDuration,
  useAnimatedTitles
};
